import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { format, parseISO, formatDistanceToNow } from 'date-fns';
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
export function formatDate(date, fmt = 'd MMM yyyy') {
    if (!date)
        return '—';
    try {
        const d = typeof date === 'string' ? parseISO(date) : date;
        return format(d, fmt);
    }
    catch {
        return '—';
    }
}
export function formatRelative(date) {
    if (!date)
        return '—';
    try {
        const d = typeof date === 'string' ? parseISO(date) : date;
        return formatDistanceToNow(d, { addSuffix: true });
    }
    catch {
        return '—';
    }
}
export function formatBottleFormat(format) {
    const map = {
        standard: 'Standard (75cl)',
        half_bottle: 'Half bottle (37.5cl)',
        magnum: 'Magnum (150cl)',
        jeroboam: 'Jeroboam (300cl)',
        rehoboam: 'Rehoboam (450cl)',
        methuselah: 'Methuselah (600cl)',
        salmanazar: 'Salmanazar (900cl)',
        balthazar: 'Balthazar (1200cl)',
        nebuchadnezzar: 'Nebuchadnezzar (1500cl)',
        sovereign: 'Sovereign (2500cl)',
    };
    return map[format] ?? format;
}
export function formatBottleFormatShort(fmt) {
    const map = {
        standard: '75cl',
        half_bottle: '37.5cl',
        magnum: 'Mag',
        jeroboam: 'Jero',
        rehoboam: 'Rehe',
        methuselah: 'Meth',
        salmanazar: 'Salm',
        balthazar: 'Balt',
        nebuchadnezzar: 'Neb',
        sovereign: 'Sov',
    };
    return map[fmt] ?? fmt;
}
export function formatDutyStatus(status) {
    const map = {
        in_bond: 'In Bond',
        duty_paid: 'Duty Paid',
        personal_import: 'Personal Import',
    };
    return map[status] ?? status;
}
export function formatPackagingType(type) {
    const map = {
        owc: 'OWC',
        owc_6: 'OWC 6',
        ibc: 'IBC',
        cardboard_carton: 'Cardboard Carton',
        loose: 'Loose',
        magnum_box: 'Magnum Box',
        mixed_case: 'Mixed Case',
        gift_box: 'Gift Box',
    };
    return map[type] ?? type;
}
export function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1).replace(/_/g, ' ');
}
export function pluralize(count, singular, plural) {
    return count === 1 ? `${count} ${singular}` : `${count} ${plural ?? singular + 's'}`;
}
